"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableErrorType = void 0;
/**
 * TableErrorType.ts
 *
 * Types of error that can occur in the express-server and are returned via
 * response to the frontend for handling or display to the user.
 */
var TableErrorType;
(function (TableErrorType) {
    TableErrorType[TableErrorType["NONE"] = 0] = "NONE";
    TableErrorType[TableErrorType["BAD_REQUEST"] = 1] = "BAD_REQUEST";
    TableErrorType[TableErrorType["UNAUTHORIZED"] = 2] = "UNAUTHORIZED";
    TableErrorType[TableErrorType["INTERNAL_ERROR"] = 3] = "INTERNAL_ERROR";
    TableErrorType[TableErrorType["TABLE_NOT_FOUND"] = 4] = "TABLE_NOT_FOUND";
    TableErrorType[TableErrorType["PLAYER_NAME_TAKEN"] = 5] = "PLAYER_NAME_TAKEN";
    TableErrorType[TableErrorType["PLAYER_ALREADY_EXISTS"] = 6] = "PLAYER_ALREADY_EXISTS";
    TableErrorType[TableErrorType["NO_SEATS_AVAILABLE"] = 7] = "NO_SEATS_AVAILABLE";
    TableErrorType[TableErrorType["ONLY_ONE_PLAYER_ALLOWED"] = 8] = "ONLY_ONE_PLAYER_ALLOWED";
    // the request contains action not supported by the server
    TableErrorType[TableErrorType["INVALID_ACTION"] = 9] = "INVALID_ACTION";
})(TableErrorType || (exports.TableErrorType = TableErrorType = {}));
//# sourceMappingURL=TableErrorType.js.map